import React from 'react';
import { Loader } from 'lucide-react';

interface LoadingSpinnerProps {
  label?: string;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  label = 'Loading',
  className = '',
}) => (
  <div className={`flex justify-center items-center py-8 ${className}`} role="status" aria-live="polite">
    <Loader size={28} className="animate-spin text-slate-600" />
    <span className="ml-2 text-slate-600">{label}...</span>
  </div>
);

export default LoadingSpinner;